<template>
    <v-modal-slot id="show-lawyers-modal"
                  @closed="closeModal">
        <template v-slot:modal-title>
            Información del letrado
        </template>

        <template v-slot:modal-content>
            <div class="row pb-3">
                <div class="col-6">
                    <strong>Nombre: </strong><br/><span>{{ lawyer.name }}</span>
                </div>

                <div class="col-6">
                    <strong>Apellidos:</strong><br/><span>{{ lawyer.surname }}</span>
                </div>
            </div>

            <div class="row">
                <div class="col-4">
                    <strong>DNI:</strong><br/><span>{{ lawyer.dni }}</span>
                </div>

                <div class="col-4">
                    <strong>Número de colegiado:</strong><br/><span>{{ lawyer.collegiate_number }}</span>
                </div>

                <div class="col-4">
                    <strong>Colegio:</strong><br/><span>{{ lawyer.college }}</span>
                </div>
            </div>
        </template>
    </v-modal-slot>
</template>

<script>

import VModal from "../../general/VModal";
import VModalSlot from "../../general/VModalSlot";

export default {
    name: "LawyersListShowModal",
    components: {VModalSlot, VModal},
    props: {
        lawyer: {
            type: Object,
            required: true,
        }
    },
    methods: {
        closeModal() {
            this.$emit('closed');
        }
    }
}
</script>
